import messages from '@intlify/unplugin-vue-i18n/messages';
import { createI18n } from 'vue-i18n';
import { datetimeFormats } from './i18n/datetimeFormats';
import { numberFormats } from './i18n/numberFormats';

export const AVAILABLE_LOCALES = ['en-US', 'de-DE'];

export const i18n = createI18n({
  legacy: false,
  locale: navigator.languages.find((locale) => AVAILABLE_LOCALES.includes(locale)) || 'en-US',
  messages,
  numberFormats,
  datetimeFormats,
});
